import baseMixin from '../mixin'

export default {
    mixins: [baseMixin],
    data() {
        return {
            formData: {
                srcLabel: 3
            },
            Tools: {
                show: true,
                data: [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary"
                    },
                    {
                        name: "批量导入",
                        operate: "upload",
                        theme: "info"
                    },
                     {
                        name: "批量提交",
                        operate: "batchSubmit",
                        more: true,
                        batch: true
                    },
                    {
                        name: "批量确认",
                        operate: "confirm",
                        more: true,
                        batch:true
                    },
                    {
                        name: "批量取消",
                        operate: "batchcancel",
                        more: true,
                        batch:true
                    },
                    {
                        name: "批量导出",
                        operate: "download",
                        more: true,
                        batch: true,
                    },
                ]
            },
        }
    },
}